import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import 'next/stylesheets/components/teams/preparation.scss';

Component('tr-team-preparation', {
  properties: {
    prepared: {
      type: Boolean,
      default: false,
      observer: 'preparedChanged',
    },

    preparationUrl: String,

    redirectUrl: String,
  },

  connected() {
    this.startCheckPreparation();
  },

  disconnected() {
    this.stopCheckPreparation();
  },

  preparedChanged() {
    if (this.prepared) {
      this.stopCheckPreparation();
      window.location.href = this.redirectUrl;
    }
  },

  startCheckPreparation() {
    this.stopCheckPreparation();
    this.checkPreparationTimer = setTimeout(() => {
      this.checkPreparation();
    }, 3000);
  },

  stopCheckPreparation() {
    if (this.checkPreparationTimer) {
      clearTimeout(this.checkPreparationTimer);
      this.checkPreparationTimer = null;
    }
  },

  checkPreparation() {
    $.getJSON(this.preparationUrl).then(({ initialized }) => {
      if (initialized) {
        this.prepared = true;
      } else {
        this.startCheckPreparation();
      }
    });
  },
});
